class NotificationService {
    axiosInstance;
    constructor(axiosInstance) {
        this.axiosInstance = axiosInstance;
    }
    wayste = {
        getUsage: async (query) => {
            const response = await this.axiosInstance.mainInstance.get(`/notifications/message/count`, {
                params: query,
            });
            return response.data;
        },
    };
    adminPortal = {
        inApp: {
            fetch: async (query = {}) => {
                const response = await this.axiosInstance.mainInstance.get('/notifications/in-app', { params: query });
                return response.data;
            },
            update: async (id, input) => {
                const response = await this.axiosInstance.mainInstance.put(`/notifications/in-app/${id}`, input);
                return response.data;
            },
        },
        createScheduledNotification: async (input) => {
            const response = await this.axiosInstance.mainInstance.post('/notifications/schedule', input);
            return response.data;
        },
        createInstantNotification: async (input) => {
            const response = await this.axiosInstance.mainInstance.post('/notifications/send', input);
            return response.data;
        },
    };
    appAdmin = {
        createInstantNotification: async (input) => {
            const response = await this.axiosInstance.appAdminInstance.post('/notifications/send', input);
            return response.data;
        },
    };
}
export default NotificationService;
//# sourceMappingURL=Notification.service.js.map